import moment from "moment";
import React, { useEffect, useState } from "react";

import {
  Table,
  Badge,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  ModalFooter,
  ButtonToolbar,
  Popover,
  PopoverHeader,
  PopoverBody,
} from "reactstrap";

import Clock from "react-live-clock";
import {
  formatDate,
  formatLoginTime,
  paramsToObject,
  usePagination,
} from "../../../utils/helpers";
import { Pagination } from "@mui/material";
import PropagateLoader from "react-spinners/PropagateLoader";
import { css } from "@emotion/react";
import PopoverOnClick from "../../../utils/HelperComponent/PopoverOnClick";
import UserListSkeleton from "../../UserManagement/UserListSkeleton";
import { decryption } from "../../HelperFunctions";
import AuthorizeButton from "./AuthorizeButton";
import { UPDATE_ATTENDANCE } from "../../../GraphQL/Mutation";
import { useMutation } from "@apollo/client";
import Swal from "sweetalert2";
import Loader from "@/containers/Account/Profile/components/Loader";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router";

const AttendanceTable = ({
  allAttendances,
  dailyAttendances,
  refetch,
  isLoadingAttendance,
  dailyAttendancesLoading,
  roles,
  setCurrentPage,
  currentPage,
  getUserByAttendance,
  userAttendance,
  data,
  setFilteredAttendance,
}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(window.location.search);
  const fromDates = queryParams.get("fromDate");

  const toDates = queryParams.get("toDate");
  const searchUser = queryParams.get("user_id");
  const searchType = queryParams.get("searchType");
  const searchPage = queryParams.get("page");

  const paramsData = paramsToObject(location.search);

  let [page, setPage] = useState(1);
  const history = useHistory();
  const updateURLParams = (params) => {
    const newParams = {
      ...params,
    };
    const queryParams = queryString.stringify(newParams);
    history.push({ search: `?${queryParams}` });
  };
  const todayCheck = moment(new Date()).format("YYYY-MM-DD");

  const PER_PAGE = 30;

  const permissions = decryption(
    JSON.parse(localStorage?.getItem("permissions"))
  );

  const [updateAttendance, { loading, error }] = useMutation(UPDATE_ATTENDANCE);

  const handleClick = async (item) => {
    const authorize = item?.attendanceInfo?.isAuthorized;

    // Show confirmation dialog using SweetAlert2
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      // Proceed only if the user confirms the action
      if (result.isConfirmed) {
        try {
          const { data } = await updateAttendance({
            variables: {
              attendanceId: item?.id,
              isAuthorized: !authorize,
            },
          });

          Swal.fire({
            title: "Updated Successfully!",
            text: "Your attendance authorization has been updated.",
            icon: "success",
          });
        } catch (err) {
          console.error("Error updating attendance:", err.message);
          Swal.fire({
            title: "Error",
            text: "There was an issue updating the attendance.",
            icon: "error",
          });
        }
      }
    });
  };
  let [color, setColor] = useState("rgb(54, 215, 183)");
  const override = css`
    margin: 0 auto;
    display: block;
    width: 100px;
  `;
  // <PropagateLoader color={color} css={override} loading={true} size={10} />
  const [dailyLoading, setDailyLoading] = useState(false);

  const handleChange = async (_e, p) => {
    setCurrentPage(p);
    setDailyLoading(true);

    try {
      updateURLParams({
        ...paramsData,
        page: p,
      });
      const res = await data?.refetch({
        ...paramsData,
        page: p,
        startedDate: fromDates ?? null,
        endDate: toDates ?? null,
        user_id: searchUser ? Number(searchUser) : null,
        rfid: null,
        searchType: searchType ? Number(searchType) : null,
      });

      const payload = res?.data?.search_attendance_between_date_and_rfid;
      setFilteredAttendance({
        data: payload?.data ?? [],
        total: payload?.paginatorInfo,
      });
    } finally {
      setDailyLoading(false);
    }
  };
  // attendance type array
  const attendanceTypeArray = [
    {
      value: 101,
      label: `Work From Home`,
    },
    {
      value: 102,
      label: `On Field Duty`,
    },
    {
      value: 201,
      label: `On Leave`,
    },
  ];
  const [popoverToggle, setPopoverToggle] = useState(false);

  return (
    <>
      <Table role="table" striped hover responsive>
        <thead>
          <tr role="row">
            <th>#</th>
            <th>Name</th>
            <th>Last Access</th>
            <th>Date</th>
            <th>First login</th>
            <th>Last logout</th>
            <th>Duration</th>
            {permissions?.includes("deny_leave") && <th>Action</th>}
          </tr>
        </thead>
        <tbody>
          {isLoadingAttendance ||
          dailyLoading ||
          getUserByAttendance?.loading ? (
            <tr>
              <td colSpan="8" className="text-center">
                <SubmitLoading color="black" />
              </td>
            </tr>
          ) : dailyAttendances?.data?.length ? (
            dailyAttendances?.data?.map((item, index) => {
              return (
                <tr
                  className={`${
                    (item?.attendance == false && "bg-not-attendance") ||
                    (item?.lateEntry == true && "bg-not-attendance")
                  }`}
                  key={item?.id}
                >
                  <th>
                    {item?.indexId
                      ? item.indexId
                      : (dailyAttendances?.paginatorInfo?.currentPage - 1) *
                          dailyAttendances?.paginatorInfo?.perPage +
                        (index + 1)}
                  </th>
                  <td>
                    {item?.userInfo?.name ? item?.userInfo?.name : item?.name}(
                    {item?.rfid ? item?.rfid : item?.additionalInfo?.rfid})
                  </td>
                  <td>
                    {item?.user_ip
                      ? item.user_ip
                      : item?.attendanceInfo[0]?.user_ip
                      ? item?.attendanceInfo[0]?.user_ip
                      : "—"}
                  </td>
                  {/* <td>{item?.login_date ? item?.login_date : "—"}</td> */}
                  <td>
                    {(!item?.login_date &&
                      !item?.attendanceInfo[0]?.login_date) ||
                    /invalid date/i.test(item?.login_date)
                      ? "—"
                      : formatDate(
                          item?.login_date
                            ? item?.login_date
                            : item?.attendanceInfo[0]?.login_date
                        )}
                  </td>
                  <td>
                    {formatLoginTime(
                      item?.login_time || item?.attendanceInfo[0]?.login_time
                    )}
                    {/* {item?.login_time
          ? `${moment(item?.login_time).format("hh:mm:ss A")} `
          : "—"} */}
                    {item?.login_device || item?.attendanceInfo[0]?.login_device
                      ? `(${
                          item?.login_device ||
                          item?.attendanceInfo[0]?.login_device
                        })`
                      : null}
                    {item?.type || item?.attendanceInfo[0]?.type ? (
                      item?.type || item?.attendanceInfo[0]?.type == 201 ? (
                        <PopoverOnClick
                          id={`on_leave${
                            item?.id || item?.attendanceInfo[0]?.type
                          }`}
                          value="On Leave"
                          buttonValue="OL"
                        />
                      ) : item?.type || item?.attendanceInfo[0]?.type == 101 ? (
                        <PopoverOnClick
                          id={`wfh${item?.id || item?.attendanceInfo[0]?.type}`}
                          value="Work From Home"
                          buttonValue="WFH"
                        />
                      ) : item?.type || item?.attendanceInfo[0]?.type == 102 ? (
                        <PopoverOnClick
                          id={`ofd${item?.id || item?.attendanceInfo[0]?.type}`}
                          value="On Field Duty"
                          buttonValue="OFD"
                        />
                      ) : null
                    ) : null}
                    {item?.reason || item?.attendanceInfo[0]?.reason ? (
                      <PopoverOnClick
                        color="primary"
                        id={`reason${item?.id || item?.attendanceInfo[0]?.id}`}
                        value={item.reason || item?.attendanceInfo[0]?.reason}
                        buttonValue="?"
                      />
                    ) : null}
                  </td>
                  <td>
                    {formatLoginTime(
                      item?.logout_time || item?.attendanceInfo[0]?.logout_time
                    )}
                    {/* {item?.logout_time
                      ? moment(item?.logout_time).format("hh:mm:ss A")
                      : "—"}{" "} */}

                    {item?.logout_device ||
                    item?.attendanceInfo[0]?.logout_device
                      ? `(${
                          item?.logout_device ||
                          item?.attendanceInfo[0]?.logout_device
                        })`
                      : null}
                  </td>
                  <td>
                    {item?.logout_time ||
                    item?.attendanceInfo[0]?.logout_time ? (
                      moment
                        .utc(
                          moment(
                            item?.logout_time ||
                              item?.attendanceInfo[0]?.logout_time,
                            "YYYY-MM-DD HH:mm:ss"
                          ).diff(
                            moment(
                              item?.login_time ||
                                item?.attendanceInfo[0]?.login_time,
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          )
                        )
                        .format("HH:mm:ss")
                    ) : item?.login_time ||
                      item?.attendanceInfo[0]?.login_time ? (
                      moment(
                        item?.login_time || item?.attendanceInfo[0]?.login_time
                      ).format("YYYY-MM-DD") ==
                      moment(new Date()).format("YYYY-MM-DD") ? (
                        <Clock
                          date={moment.utc(
                            moment(new Date(), "YYYY-MM-DD HH:mm:ss").diff(
                              moment(
                                item?.login_time ||
                                  item?.attendanceInfo[0]?.login_time,
                                "YYYY-MM-DD HH:mm:ss"
                              )
                            )
                          )}
                          format={"HH:mm:ss"}
                          ticking={true}
                          timezone={"utc"}
                        />
                      ) : (
                        "—"
                      )
                    ) : (
                      "—"
                    )}
                  </td>
                  {permissions?.includes("deny_leave") && (
                    <td>
                      <AuthorizeButton
                        item={item?.attendanceInfo[0]}
                        data={item}
                        authorized={item?.attendanceInfo[0]?.isAuthorized}
                        onClick={handleClick}
                      />
                    </td>
                  )}
                </tr>
              );
            })
          ) : allAttendances?.data?.length > 0 ? (
            allAttendances?.data?.map((item, index) => {
              return (
                <tr
                  className={`${
                    (item?.attendance == false && "bg-not-attendance") ||
                    (item?.lateEntry == true && "bg-not-attendance")
                  }`}
                  key={item?.id}
                >
                  {/* <th>{item?.indexId ? item?.indexId : index + 1}</th> */}
                  <th>
                    {item?.indexId
                      ? item.indexId
                      : (allAttendances?.total?.currentPage - 1) *
                          allAttendances?.total?.perPage +
                        (index + 1)}
                  </th>
                  <td>
                    {item?.userInfo?.name}({item?.rfid})
                  </td>
                  <td>{item?.user_ip ? item.user_ip : "—"}</td>
                  {/* <td>{item?.login_date ? item?.login_date : "—"}</td> */}
                  <td>
                    {!item?.login_date || /invalid date/i.test(item?.login_date)
                      ? "—"
                      : formatDate(item?.login_date)}
                  </td>
                  <td>
                    {formatLoginTime(item?.login_time)}

                    {item?.login_device ? `(${item?.login_device})` : null}
                    {item?.type ? (
                      item?.type == 201 ? (
                        <PopoverOnClick
                          id={`on_leave${item?.id}`}
                          value="On Leave"
                          buttonValue="OL"
                        />
                      ) : item?.type == 101 ? (
                        <PopoverOnClick
                          id={`wfh${item?.id}`}
                          value="Work From Home"
                          buttonValue="WFH"
                        />
                      ) : item?.type == 102 ? (
                        <PopoverOnClick
                          id={`ofd${item?.id}`}
                          value="On Field Duty"
                          buttonValue="OFD"
                        />
                      ) : null
                    ) : null}
                    {item?.reason ? (
                      <PopoverOnClick
                        color="primary"
                        id={`reason${item?.id}`}
                        value={item.reason}
                        buttonValue="?"
                      />
                    ) : null}
                  </td>
                  <td>
                    {formatLoginTime(item?.logout_time)}
                    {/* {item?.logout_time
                      ? moment(item?.logout_time).format("hh:mm:ss A")
                      : "—"}{" "} */}

                    {item?.logout_device ? `(${item?.logout_device})` : null}
                  </td>
                  <td>
                    {item?.logout_time ? (
                      moment
                        .utc(
                          moment(item?.logout_time, "YYYY-MM-DD HH:mm:ss").diff(
                            moment(item?.login_time, "YYYY-MM-DD HH:mm:ss")
                          )
                        )
                        .format("HH:mm:ss")
                    ) : item?.login_time ? (
                      moment(item?.login_time).format("YYYY-MM-DD") ==
                      moment(new Date()).format("YYYY-MM-DD") ? (
                        <Clock
                          date={moment.utc(
                            moment(new Date(), "YYYY-MM-DD HH:mm:ss").diff(
                              moment(item?.login_time, "YYYY-MM-DD HH:mm:ss")
                            )
                          )}
                          format={"HH:mm:ss"}
                          ticking={true}
                          timezone={"utc"}
                        />
                      ) : (
                        "—"
                      )
                    ) : (
                      "—"
                    )}
                  </td>
                  {permissions?.includes("deny_leave") && (
                    <td>
                      <AuthorizeButton
                        item={item}
                        // authorized={item}
                        data={item?.userInfo}
                        authorized={item?.isAuthorized}
                        onClick={handleClick}
                      />
                    </td>
                  )}
                </tr>
              );
            })
          ) : userAttendance?.length ? (
            userAttendance?.map((item, index) => {
              return (
                <tr
                  className={`${
                    (item?.attendance == false && "bg-not-attendance") ||
                    (item?.lateEntry == true && "bg-not-attendance")
                  }`}
                  key={item?.id}
                >
                  <th>{item?.indexId ? item?.indexId : index + 1}</th>
                  <td>
                    {item?.userInfo?.name}({item?.rfid})
                  </td>
                  <td>{item?.user_ip ? item.user_ip : "—"}</td>
                  {/* <td>{item?.login_date ? item?.login_date : "—"}</td> */}
                  <td>
                    {!item?.login_date || /invalid date/i.test(item?.login_date)
                      ? "—"
                      : formatDate(item?.login_date)}
                  </td>
                  <td>
                    {formatLoginTime(item?.login_time)}

                    {item?.login_device ? `(${item?.login_device})` : null}
                    {item?.type ? (
                      item?.type == 201 ? (
                        <PopoverOnClick
                          id={`on_leave${item?.id}`}
                          value="On Leave"
                          buttonValue="OL"
                        />
                      ) : item?.type == 101 ? (
                        <PopoverOnClick
                          id={`wfh${item?.id}`}
                          value="Work From Home"
                          buttonValue="WFH"
                        />
                      ) : item?.type == 102 ? (
                        <PopoverOnClick
                          id={`ofd${item?.id}`}
                          value="On Field Duty"
                          buttonValue="OFD"
                        />
                      ) : null
                    ) : null}
                    {item?.reason ? (
                      <PopoverOnClick
                        color="primary"
                        id={`reason${item?.id}`}
                        value={item.reason}
                        buttonValue="?"
                      />
                    ) : null}
                  </td>
                  <td>
                    {formatLoginTime(item?.logout_time)}
                    {/* {item?.logout_time
                      ? moment(item?.logout_time).format("hh:mm:ss A")
                      : "—"}{" "} */}

                    {item?.logout_device ? `(${item?.logout_device})` : null}
                  </td>
                  <td>
                    {item?.logout_time ? (
                      moment
                        .utc(
                          moment(item?.logout_time, "YYYY-MM-DD HH:mm:ss").diff(
                            moment(item?.login_time, "YYYY-MM-DD HH:mm:ss")
                          )
                        )
                        .format("HH:mm:ss")
                    ) : item?.login_time ? (
                      moment(item?.login_time).format("YYYY-MM-DD") ==
                      moment(new Date()).format("YYYY-MM-DD") ? (
                        <Clock
                          date={moment.utc(
                            moment(new Date(), "YYYY-MM-DD HH:mm:ss").diff(
                              moment(item?.login_time, "YYYY-MM-DD HH:mm:ss")
                            )
                          )}
                          format={"HH:mm:ss"}
                          ticking={true}
                          timezone={"utc"}
                        />
                      ) : (
                        "—"
                      )
                    ) : (
                      "—"
                    )}
                  </td>
                  {permissions?.includes("deny_leave") && (
                    <td>
                      <AuthorizeButton
                        item={item}
                        // authorized={item}
                        data={item}
                        authorized={item?.isAuthorized}
                        onClick={handleClick}
                      />
                    </td>
                  )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="7" className="text-success text-center">
                <b>Today you have no attendance.</b>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      {
        <Pagination
          count={
            dailyAttendances?.paginatorInfo?.lastPage ||
            allAttendances?.total?.lastPage
          }
          page={currentPage}
          onChange={handleChange}
        />
      }
    </>
  );
};

export default AttendanceTable;
